const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('overlay');
   
    const init = function() {
		const closeBtn = document.getElementById('closeOverlay'),
		      popup = document.getElementsByClassName('js-popup')[0];
		      
        let wh;
		
		window.closeOverlay = function() {
			el.classList.add('is-hidden');
			el.classList.remove('is-visible');
			document.removeEventListener('click', window.clickOutside);
			enableBodyScroll(el);

			if (el.getElementsByClassName('js-content').length > 0) {
    			for (let i = 0; i < el.getElementsByClassName('js-content').length; i++) {
        			el.getElementsByClassName('js-content')[i].classList.add('is-hidden');
    			}
			}
		}
		
		window.clickOutside = function(e) {
            console.log(e.target.classList);
            if (e.target.closest('.js-popup') === null) {
                closeOverlay();
                document.removeEventListener('click', window.clickOutside);
        	}
        };
		
		window.checkWindowHeight = function() {
            wh = window.innerHeight;       
            
            if (wh <= popup.clientHeight) {
				popup.classList.add('is-relative');
            } else {
	            popup.classList.remove('is-relative');
            }
        };

		closeBtn.addEventListener('click', closeOverlay);
		
		document.addEventListener('keydown', function(evt) {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                closeOverlay();
            }
        });
        
        window.addEventListener('resize', checkWindowHeight);
        checkWindowHeight();
	};


    el ? init() : false;
    
    
}, false);